module.exports = __webpack_public_path__ + "img/box-dist.967d9220.svg";